export default __webpack_public_path__ + "static/media/mobile-icon.518429ab.svg";